module.exports = __webpack_public_path__ + "assets/img/plant-2.e44437c3.png";